module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/lemon-6a8f4b7a.webp";